/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/cite/citeui
 */

import { Plugin } from 'ckeditor5/src/core';
import { ButtonView } from 'ckeditor5/src/ui';

import citeIcon from '../../theme/icons/cite.svg';

const CITE = 'cite';

/**
 * The cite UI feature. It introduces the cite button.
 *
 * @extends module:core/plugin~Plugin
 */
export default class CiteUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'CiteUI';
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;

		// Add bold button to feature components.
		editor.ui.componentFactory.add( CITE, locale => {
			const command = editor.commands.get( CITE );
			const view = new ButtonView( locale );

			view.set( {
				label: t( 'Cite' ),
				icon: citeIcon,
				keystroke: 'CTRL+T',
				tooltip: true,
				isToggleable: true
			} );

			view.bind( 'isOn', 'isEnabled' ).to( command, 'value', 'isEnabled' );

			// Execute command.
			this.listenTo( view, 'execute', () => {
				editor.execute( CITE );
				editor.editing.view.focus();
			} );

			return view;
		} );
	}
}
